import GeneralInfo from "@/modules/company/pages/GeneralInfo.vue";
import UBO from "@/modules/company/pages/UBO.vue";
import Finish from "@/modules/finish/pages/Finish.vue";

export default [
  {
    path: "/company/general-info/",
    name: "general-info",
    component: GeneralInfo,
  },
  {
    path: "/company/ubo/",
    name: "ubo",
    component: UBO,
  },
  {
    path: "/finish-company",
    name: "finish-company",
    component: Finish,
  },
];
